import React, { useEffect } from 'react';
import Form from '../sso-login-form';
import type { IProps } from './types';
import TestimonialsCarousel from '../../../../shared/components/testimonials-carousel';
import { SHLogoDark } from '../../../../shared/svg';
import { SHLogoTypography } from '../../../../shared/svg/sh-typography';
import { RequestStatus } from '../../../../shared/enums/request-status';
import { isInternalUrl } from '../../../../shared/utils/is-internal-url';

const SSOLogin: React.FC<IProps> = ({
  agencyConfig,
  agencyConfigRequestStatus,
}) => {
  const isWhitelabel = !!agencyConfig?.clientBaseUrl;
  return (
    <>
      {(agencyConfigRequestStatus === RequestStatus.Pending &&
        !isInternalUrl()) ||
      isWhitelabel ? null : (
        <div className="testimonials-container">
          <div className="d-flex align-items-center">
            <SHLogoDark />
            <div className="bs-ml-10">
              <SHLogoTypography />
            </div>
          </div>

          <TestimonialsCarousel />
          <p className="copyright">
            &copy;{`${new Date().getFullYear()} Saleshandy`}
          </p>
        </div>
      )}
      <Form />
    </>
  );
};

export default SSOLogin;
